<template>
    <div class="order-block">
        <div class="order-block__title-big text-uppercase"><span><b>Ваш заказ:<b/></span></div>
        <div class="catalog-product-list text-center row">
            <div class="col-12 responsive-table-wrapper">
                <table class="table responsive-table responsive-table_w-700">
                    <thead class="catalog-product-list__table-headers">
                    <tr>
                        <th class="text-center">Наименование</th>

                        <th class="text-center">Артикул</th>
                        <th class="text-center">Производитель</th>
                        <th class="text-center">Кол-во</th>
                        <th class="text-center">Цена</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(product, index) in dataList" :key="index" class="catalog-product-item">
                        <td class="catalog-product-item__name"><span>{{product.data.NAME}}</span></td>
     

                       <td><span v-if="product.data.PROPERTY_CML2_ARTICLE_VALUE">{{product.data.PROPERTY_CML2_ARTICLE_VALUE}}</span>
                         <span v-else>не указано</span></td>
                      <td><span v-if="product.columns.PROPERTY_MANUFACTURER_VALUE">{{product.columns.PROPERTY_MANUFACTURER_VALUE[0].value}}</span>
                        <span v-else>не указано</span></td>
                         <td><span>{{product.data.QUANTITY}}</span></td>
                         <td class="catalog-product-item__price">{{product.data.PRICE}} <i class="fa fa-rub"></i></td>
                     </tr>
                     </tbody>
                 </table>
             </div>
         </div>
     </div>
 </template>

 <script>
   export default {
     name: 'product-list',
     props: {
       dataList: {
         type: [Object, Array],
         default () {
           return {}
         }
       }
     }
   }
 </script>



// WEBPACK FOOTER //
// src/vue/components/order/components/ProductList.vue